import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-roaster',
  templateUrl: './roaster.component.html',
  styleUrls: ['./roaster.component.css']
})
export class RoasterComponent implements OnInit {

  constructor(private commonService:CommonService) { }
  ngOnInit(): void {

  }
  isSpocMenuOpen: boolean = false;
  isSpocMenuActive: boolean = false;
  isRosterMenuActive : boolean =false;
  isRosterOpen:boolean =false;
  isRosterPlanOpen:boolean=false;
  isRosterPlanMenuActive:boolean=false;
  toggleSpocMenu(val:any) {
    this.isRosterMenuActive=false;
    this.isRosterOpen=false;
    this.isRosterPlanMenuActive=false;
    this.isSpocMenuActive=false;
    this.isSpocMenuOpen=false;
    this.isRosterPlanOpen=false;
    if(val === 'spoc'){
      this.isSpocMenuOpen = !this.isSpocMenuOpen;
      this.isSpocMenuActive = !this.isSpocMenuActive;
    }
   else if(val === 'roster'){
  this.isRosterMenuActive=!this.isRosterMenuActive;
  this.isRosterOpen=!this.isRosterOpen;
   }
   else if(val === 'rosterPlan'){
    this.isRosterPlanOpen=!this.isRosterPlanOpen;
    this.isRosterPlanMenuActive=!this.isRosterPlanMenuActive;
   }
  }


}
